export default "__VITE_ASSET__a590691f__"